import { useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'src/components/Button';
import Tabs from 'src/components/Tabs';
import { IconComplete, IconIncomplete, IconPlus, IconSpinner } from 'src/icons';
import { getMonthName } from 'src/logic/getMonthName';
import { routes } from 'src/routes';
import { useAppDispatch } from 'src/store';

import { useInvoiceDetailsQuery } from '../billing/billingApi';
import { BillingHeader } from '../billing/BillingHeader';
import BillingSignatureModal from '../billing/BillingSignatureModal';
import { setInvoicesIdsForSignature } from '../billing/billingSlice';
import { ActivitiesList } from './ActivitiesList';
import { ActivityModal } from './ActivityModal';
import { EmptyCoordinationState } from './EmptyCoordinationState';

export const LogCoordination = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [isActivityModalOpen, setIsActivityModalOpen] = useState(false);
  const { data: invoiceData, isLoading: isInvoiceLoading } = useInvoiceDetailsQuery(id!, {
    skip: !id,
  });
  const activities = invoiceData?.activities;

  const tabs = [
    {
      label: 'Activities',
      count: activities?.activities?.length || 0,
      id: 'activities',
      to: `${routes.billing.root}/${routes.billing.logCoordination.root.replace(':id', id || '')}`,
      isSelected: true,
    },
  ];

  const onFinalizeBilling = () => {
    dispatch(setInvoicesIdsForSignature([id!]));
  };

  const handleAddActivity = () => {
    setIsActivityModalOpen(true);
  };

  if (isInvoiceLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <IconSpinner className="h-8 w-8 animate-spin" />
      </div>
    );
  }
  return (
    <div className="flex min-h-full flex-col bg-neutral-white">
      <BillingHeader onFinalize={onFinalizeBilling} />
      <Tabs items={tabs} underline className="px-4 sm:px-10" />
      <div className="flex h-full grow justify-center gap-12 bg-neutral-950 p-4 py-8 md:p-6">
        <div className="flex w-full flex-col">
          <div className="flex justify-between sm:px-4">
            <div className="flex flex-col gap-1">
              <p className=" text-heading-xl-mobile text-neutral-200 ">
                {invoiceData?.year &&
                  invoiceData.month &&
                  `${getMonthName(invoiceData.month)} ${invoiceData.year}`}
              </p>
              {activities?.activities && activities.activities.length > 0 && (
                <>
                  <div className="flex items-center gap-1">
                    {activities.activities.length < activities.minimumActivitiesCount ? (
                      <IconIncomplete className="h-4 w-4" />
                    ) : (
                      <IconComplete className="h-4 w-4 text-accent-verdigris-500" />
                    )}
                    <p className="text-body-sm-desktop text-neutral-300">
                      {activities.activities.length}/{activities.minimumActivitiesCount} activities
                      logged
                    </p>
                  </div>
                  <div className="flex items-center gap-1">
                    {activities.contactWithParentRule ? (
                      <IconComplete className="h-4 w-4 text-accent-verdigris-500" />
                    ) : (
                      <IconIncomplete className="h-4 w-4" />
                    )}
                    <p className="text-body-sm-desktop text-neutral-300">
                      Parent conference logged
                    </p>
                  </div>
                </>
              )}
            </div>
            {activities?.activities && activities.activities.length > 0 && (
              <Button preset="secondary" Icon={IconPlus} onClick={handleAddActivity}>
                Add Activity
              </Button>
            )}
          </div>
          {activities && activities.activities.length > 0 ? (
            <div className="pb-6 pt-9 sm:px-4">
              <ActivitiesList activities={activities?.activities || []} />
            </div>
          ) : (
            <EmptyCoordinationState onAddActivity={handleAddActivity} />
          )}
        </div>
      </div>
      <ActivityModal
        open={isActivityModalOpen}
        onOpenChange={setIsActivityModalOpen}
        month={invoiceData?.month}
        year={invoiceData?.year}
        enableOnlyProvidedMonthAndYear={true}
      />
      <BillingSignatureModal />
    </div>
  );
};
